<template>
  <div>
    <SelectServer ref="SelectServer" v-on:selectNetworkAssetComplete="selectServerComplete"></SelectServer>
    <Modal v-model="modal11" fullscreen title="Fullscreen Modal">
        <span v-html="logContent"/>
    </Modal>
    <Modal
      v-model="execModal"
      :title="title"
      :mask-closable="false"
      @on-cancel="execModalCancel"
      width="400">
      <Form ref="execForm" :model="execForm" :label-width="110">
        <!-- <Alert>如果不选择历史版本，则默认和设备上当前运行的配置进行对比</Alert> -->
        <FormItem :label="'目标服务器(' + waitExecServerLength + ')'">
          <Button type="default" icon="ios-desktop-outline" @click="openSelectServerModal" v-if="!waitExecServerLength" class="w-100 align-left">选择目标设备</Button>
          <a v-on:click="openSelectServerModal" v-else>继续选择 </a>
          <Tag color="primary" v-for="(value, key, index) in waitExecServer" :key="'wait_hostname_' + index" v-if="value">{{ key }}</Tag>
        </FormItem>
        <FormItem label="并发执行设备数量" :label-width="110">
           <InputNumber :max="100" :min="1" v-model="execForm.size" class="w-100"></InputNumber>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" :loading="execIng" style="margin-right: 8px" @click="execOk">执行</Button>
        <Button @click="execModal = false">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
// import { getNetworktAllConfig, compareConfig } from '@/api/network'
import SelectServer from './components/select-network-asset'

export default {
  name: 'config-backup-modal',
  components: {
    SelectServer
  },
  data () {
    return {
      logContent: '',
      modal11: false,
      scriptData: {},
      scriptDataTarget: {},
      title: '配置',
      execModal: false,
      execIng: false,
      allConfigList: [],
      execForm: {
        size: 3
      },
      execRule: {
      },
      waitExecServer: {},
      waitExecServerLength: 0
    }
  },
  methods: {
    // 选择服务器完成回调
    selectServerComplete (server, length) {
      this.waitExecServer = server
      this.waitExecServerLength = length
    },
    // 打开服务器选择Modal
    openSelectServerModal () {
      this.$refs.SelectServer.openSelectNetworkAssetModal({}, this.waitExecServer)
    },
    // 打开执行Modal
    openModal () {
      this.title = '配置批量备份'
      this.execModal = true
    },
    // 关闭执行Modal
    execModalCancel () {
      this.execForm.size = 3
      this.waitExecServer = {}
      this.waitExecServerLength = 0
    },
    // 开始执行脚本
    execOk () {
      let serverIds = []
      for (let i in this.waitExecServer) {
        if (this.waitExecServer[i]) {
          serverIds.push(this.waitExecServer[i])
        }
      }
      if (serverIds.length > 0) {
        this.$emit('execComplete', serverIds)
        this.execModal = false
      } else {
        this.$Notice.error({ title: '至少选择一台设备进行备份 ！' })
      }
    }
  }
}
</script>
